import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "@main/producers/actions/details/useDetailsAction";
import useExportAction from "@main/producers/actions/export/useExportAction";
import useResetPasswordMailAction from "@main/producers/actions/reset-password-mail/useResetPasswordMailAction";
import useActiveOrDisableAccountAction from "@main/producers/actions/active-or-disable-account/useActiveOrDisableAccountAction";
import { UserCirclePlus } from "@phosphor-icons/react";
import useChangePasswordAction from "@main/producers/actions/change-password/useChangePasswordAction";

function ProducersPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  // List (table) hook
  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  // Create modal
  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  // Remove modal
  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  // Export
  const { exportFunction } = useExportAction();

  // Details navigation
  const { detailsFunction } = useDetailsAction(0, formDefaultValues);

  // Reset password email modal
  const {
    prepareResetPasswordFunction,
    actionTemplate: resetPasswordTemplate,
  } = useResetPasswordMailAction();

  // Activate/Disable account modal
  const {
    prepareActiveOrDisableFunction,
    actionTemplate: activeOrDisableTemplate,
  } = useActiveOrDisableAccountAction(indexFunction);

  // Change password modal
  const {
    actionTemplate: changePasswordModal,
    prepareChangePasswordFunction,
  } = useChangePasswordAction();

  /**<newActionsHooks**/

  // Table configuration
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction,
        indexFunction,
        exportFunction,
        prepareRemoveFunction,
        prepareResetPasswordFunction,
        prepareActiveOrDisableFunction,
        detailsFunction,
        prepareChangePasswordFunction,
        /**newActionsTableConfig**/
      }),
    [
      initializeFunction,
      indexFunction,
      exportFunction,
      prepareRemoveFunction,
      prepareResetPasswordFunction,
      prepareActiveOrDisableFunction,
      detailsFunction,
      prepareChangePasswordFunction,
    ]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <UserCirclePlus size={24} /> {t("producers")}
        </Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {removeActionTemplate}
        {resetPasswordTemplate}
        {activeOrDisableTemplate}
        {changePasswordModal}
      </Card.Body>
    </Card>
  );
}

export default ProducersPage;
